import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import * as firebase from 'firebase/app'
import PostsForm from './PostsForm'

class NewsCard extends Component {
  
  constructor () {
    super()

  }

  render() {

    const post = this.props.post

    let inCourse = false
    let usesStr = ''
    if ( post.sessions!==undefined && post.users!==undefined ) {
      Object.keys(post.users).map ( uKey => {
        if ( uKey === this.props.user.key ) {
          inCourse = true
        }
        usesStr += post.users[uKey] + '\n'
      })
    }

    return (
      <div className="postDiv centered" key={post.key}>
        <small>
          {post.creationDate} 
          &nbsp;&nbsp;
          { this.props.user.role!=='user'?
            <i className="material-icons btnIcon2" title="Eliminar" onClick={()=>this.props.removePost(post.key)}>delete</i>
          : null }
          &nbsp;&nbsp;
          { this.props.user.role!=='user'?
            <i className="material-icons btnIcon2" title="Editar" onClick={()=>this.props.editPost(post)}>edit</i>
          : null }
        </small>
        <br/>
        <b>{post.title}</b>
        <br/>
        <br/>
        { post.imageUrl!==undefined && post.imageUrl!=='' ?
          <center>
            <a href={post.imageUrl} target="_out_">
              <img alt="imagen" src={post.imageUrl} className="newsImg" />
            </a>
            <br/>
          </center>
        : null }
        <br/>
        { this.props.showCourseInfo==="true" && post.sessions!==undefined ?
          <div className="row sessionsDiv">
            <div className="col-md-6">
              <b>Sesiones</b>:
              <br/>
              { Object.keys(post.sessions).map ( ses => {
                  const s = post.sessions[ses]

                  return (
                    <div key={ses}>
                      <small>&nbsp;&nbsp;&nbsp;&nbsp;
                        {s.startDate} {s.startTime} - {s.startDate!==s.endDate?s.endDate:null} {s.endTime}
                      </small>
                    </div>
                  )
                })
              }
            </div>
            <div className="col-md-6">

              <span className="floatRight">
                <i className="material-icons btnIcon" title={usesStr}>person</i>
                <br/>
                { post.users!==undefined?Object.keys(post.users).length:0 }
              </span>

              { inCourse ?
                <button className='btn btn-lignht btn-sm floatRight' onClick={ () => this.removeFromCourse( post.key ) }>Darse de baja del curso</button>
                :
                <button className='btn btn-lignht btn-sm floatRight' onClick={ () => this.addToCourse( post.key ) }>Inscribirse al curso</button>
              }
              
            </div>
          </div>
        : null }

        <br/>
        <p className="postDescDiv">
          {post.desc}
        </p>
        { this.props.showCourseInfo==="false" && post.sessions!==undefined ?
             <center>
               <button className='btn btn-lignht btn-sm' onClick={ () => this.props.showPost(post) }>Ver información del curso</button>
             </center> 
          : post.sessions!==undefined ?
            <center>
              <button className='btn btn-lignht btn-sm' onClick={ () => this.props.backToNews() }>Volver</button>
            </center>  
            : null 
          }
          <br/>
          <br/>
      </div>
    )
  }

  componentDidMount () {
    
    firebase.database().ref("posts").on ( 'value', posts => {
      let postsList = []
      posts.forEach ( post => {
        let p = post.val()
        p.key = post.key
        postsList.push(p)
      })
      this.setState({
        posts: postsList.reverse()
      })
    })

    firebase.database().ref("users").on ( 'value', users => {
      let usersList = []
      let userObj = null
      users.forEach ( user => {
        let u = user.val()
        u.key = user.key
        if (u.role==='user'){
          usersList.push(u)
        }
        if ( u.email===firebase.auth().currentUser.email){
          userObj = u
        }
      })

      this.setState({
        users: usersList,
        user: userObj
      })

    })

  }

  addNews () {
    this.setState({
      showForm: true
    })
  }

  backToNews () {
    this.setState({
      showForm: false,
      postToShow: null,
      postToEdit: null
    })
  }

  addToCourse ( postKey ) {
    firebase.database().ref("posts").child(postKey).child("users").child(this.props.user.key).set(this.props.user.name)
  }

  removeFromCourse ( postKey ) {
    firebase.database().ref("posts").child(postKey).child("users").child( this.props.user.key ).remove()
  }

  removePost ( postKey ) {
    firebase.database().ref("posts").child(postKey).remove()
  }

  editPost ( post ) {
    console.log('editPost!')
    this.setState ({
      postToEdit: post,
      showForm: true
    })
  }

}

export default NewsCard
